<template>
	<div class="app">
		<div class="wrapper">
			<div class="menu-wrap">
				<input type="checkbox" class="toggler">
				<div class="hamburger">
					<div></div>
				</div>
				<div class="menu">
					<div>
						<ul>
							<li><router-link :to="{ name: 'smart_electricity' }" active-class="tabbar-router" exact>智慧用电</router-link></li>
							<li><router-link :to="{ name: 'smart_fire' }" active-class="tabbar-router" exact>智慧消防</router-link></li>
							<li><router-link :to="{ name: 'smart_community' }" active-class="tabbar-router" exact>智慧社区</router-link></li>
							<li><router-link :to="{ name: 'smart_statistics' }" active-class="tabbar-router" exact>隐患统计</router-link></li>
							<!-- <li><router-link :to="{ name: 'smart_energy' }">能耗分析</router-link></li> -->
						</ul>
					</div>
				</div>
			</div>
			<div class="page">
				<router-view />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},

		computed: {

		},

		mounted() {

		},

		methods: {

		}
	}
</script>

<style src="./index.css" scoped>
	
</style>
